import { Validator } from '@vista-digital/validator';
export const occSeatingSeatSelectionRuleConfigValidator = Validator.object({
    enabled: Validator.boolean()
});
//# sourceMappingURL=seat-selection-rule.js.map